import { useDispatch } from "react-redux";

import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { clearThreadContext } from "app/pages/sales-intelligence/modules/ai-agent/sub-modules/lead-generator/store";

type Props = {
    onRefresh?: VoidFunction;
};

export const AiRetryButton = ({ onRefresh }: Props) => {
    const dispatch = useDispatch();

    const handleRefreshClick = (): void => {
        void dispatch(clearThreadContext());
        onRefresh?.();
    };

    return <Button onClick={handleRefreshClick}>{translate("si.common.refresh")}</Button>;
};
